import type {User} from '@hconnect/common/types'

import type {ChecklistBaseDto, YesNoItemWithComment} from './checklist-shared.types'
import {ChecklistTemplateKind} from './hroc-checklists.types'

export enum Hazard {
  VehiclesEquipmentPedestrianSegregation = 'vehiclesEquipmentPedestrianSegregation',
  ElectricalEnergizedEquipmentLOTO = 'electricalEnergizedEquipmentLOTO',
  MechanicalStoredEnergyPressurizedSystems = 'mechanicalStoredEnergyPressurizedSystems',
  RotatingEquipment = 'rotatingEquipment',
  WorkingAtHeights = 'workingAtHeights',
  ConfinedSpace = 'confinedSpace',
  GravityOverheadHazardsFallingItemsRigging = 'gravityOverheadHazardsFallingItemsRigging',
  WorkOverWater = 'workOverWater',
  UseOfHeavyEquipment = 'useOfHeavyEquipment',
  LiftingOperations = 'liftingOperations',
  SharpToolsCuts = 'sharpToolsCuts',
  ThermalFireExplosion = 'thermalFireExplosion',
  ElectricalCordsToolConditions = 'electricalCordsToolConditions',
  SpillPotentialEnvironmentalImpactConcerns = 'spillPotentialEnvironmentalImpactConcerns',
  WeatherConditions = 'weatherConditions',
  WorkEnvironmentClimateHotCold = 'workEnvironmentClimateHotCold',
  ErgonomicsBodyPositionLineOfFire = 'ergonomicsBodyPositionLineOfFire',
  Radiation = 'radiation',
  WorkplaceNoiseDustFumesMistAsbestos = 'workplaceNoiseDustFumesMistAsbestos',
  ChemicalAndHazardousMaterialManualHandling = 'chemicalAndHazardousMaterialManualHandling',
  TrainingPersonalLimitations = 'trainingPersonalLimitations',
  FirstTimePerformingTaskNewTask = 'firstTimePerformingTaskNewTask',
  WorkEnvironmentPermitRequired = 'workEnvironmentPermitRequired',
  OverlappingWorkAreas = 'overlappingWorkAreas',
  WorkingAlone = 'workingAlone',
  Other = 'other'
}

export enum Risk {
  FallFromHeight = 'fallFromHeight',
  EngulfmentOrEntrapment = 'engulfmentOrEntrapment',
  SlipTripFall = 'slipTripFall',
  CutsLacerations = 'cutsLacerations',
  CrushInjuries = 'crushInjuries',
  PinchInjuries = 'pinchInjuries',
  StrainsSprains = 'strainsSprains',
  Electrocution = 'electrocution',
  CaughtInEquipment = 'caughtInEquipment',
  Drowning = 'drowning',
  Burns = 'burns',
  ForeignBodyInEye = 'foreignBodyInEye',
  ArcFlash = 'arcFlash',
  Frostbite = 'frostbite',
  HeatStress = 'heatStress',
  ImpactOrAbrasiveInjuries = 'impactOrAbrasiveInjuries',
  VehicleAccident = 'vehicleAccident',
  ChemicalExposure = 'chemicalExposure',
  LossOfConsciousness = 'lossOfConsciousness',
  HearingDamage = 'hearingDamage',
  HarmToCoworkers = 'harmToCoworkers',
  Other = 'other'
}

export type TakeFiveChecklistData = {
  safety: {
    peopleInformed: YesNoItemWithComment
    rightTools: YesNoItemWithComment
    fitForDuty: YesNoItemWithComment
    riskRecognized: YesNoItemWithComment
    reasonToWorkSafe: string // max128
    supervisor: User | null
  } | null
  hazardAssessment: {
    workToBeDone: string // max512
    hazards: Hazard[]
    hazardsComment: string // max512
    risks: Risk[]
    risksComment: string // max512
    eliminateControlHazard: string // max512
  } | null
}

export type TakeFiveChecklistDto = ChecklistBaseDto & {
  kind: ChecklistTemplateKind.TakeFive
  data?: TakeFiveChecklistData
}
